import React from 'react';

import {
  ContestReattempt,
  LESSON_TYPES,
  findLessonByLessonType,
} from 'features/classCreation';
import styles from './EditGroupContestSummary.module.scss';

function EditGroupContestSummary({ sbatGroup }) {
  const { lessons } = sbatGroup.academy_topic;
  const contestLesson = findLessonByLessonType({
    lessons,
    lessonType: LESSON_TYPES.contest,
  });
  const { meta } = contestLesson;
  const { interviewbit_tests: interviewbitTests } = meta;

  return (
    <div className={styles.root}>
      {interviewbitTests.map((interviewbitTest) => (
        <ContestReattempt
          interviewbitTest={interviewbitTest}
          key={interviewbitTest.test_id}
        />
      ))}
    </div>
  );
}

export default EditGroupContestSummary;
